/**
 * Les mesures de `<SamPeek>` que la scène du live lit pour lui garder sa place
 * (`organisms/LiveStage/stageLayout.ts`). Pures : elles se lisent sous Jest.
 */
import { TOUCH_TARGET } from "../../utils/touchTarget"

/** Au-delà, la bulle passe à la ligne : elle ne couvre pas l'énoncé d'un bord à l'autre. */
export const SAM_PEEK_MAX_WIDTH = 248
/** Tout l'aperçu au plus large : sa bulle, et la cible d'un doigt autour de sa croix. */
export const SAM_PEEK_WIDTH = SAM_PEEK_MAX_WIDTH + TOUCH_TARGET
/** Tout l'aperçu au plus haut : sa bulle sur trois lignes, sa croix comprise. */
export const SAM_PEEK_MAX_HEIGHT = 80
